/**
 * Feature flags configuration
 *
 * These flags control various features in the application.
 * In production, you may want to use environment variables or a feature flag service.
 */

const ENVIRONMENT = import.meta.env.MODE || 'development';

export const FEATURE_FLAGS = {
  /**
   * Enable normalized error handling across the app
   * - Error boundaries on routes and root
   * - Standardized error format
   * - Error bus for centralized handling
   */
  useNormalizedErrors: true,

  /**
   * Enable telemetry and error tracking
   * - Sentry integration (when DSN is provided)
   * - Web Vitals monitoring
   * - Global error handlers
   */
  enableTelemetry: true,

  /**
   * Attach request ID header to all API requests
   * - Enables distributed tracing
   * - Correlates frontend errors with backend logs
   * - Recommended for production
   */
  attachRequestIdHeader: true,

  /**
   * Enable PDF download functionality
   * Still in development
   */
  enableDownloadPdf: false,

  /**
   * Enable verbose logging in development
   */
  enableVerboseLogging: ENVIRONMENT === 'development',

  /**
   * Enable performance monitoring
   * - Web Vitals tracking
   * - API response time monitoring
   */
  enablePerformanceMonitoring: true,
};

export type FeatureFlag = keyof typeof FEATURE_FLAGS;

/**
 * Check if a feature is enabled.
 */
export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return Boolean(FEATURE_FLAGS[flag]);
}

/**
 * Get all feature flags (useful for debugging).
 */
export function getAllFlags(): typeof FEATURE_FLAGS {
  return { ...FEATURE_FLAGS };
}
